import { config } from "@src/config";
import { ChartFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { Button, Form } from "antd";
import { FormInstance } from "antd/lib/form";
import { ApplyValueStateType } from ".";
import { useGetGeneralField } from "@src/hooks/ab-testing/use-get-general-field";
import { getRuleFilter } from "./funnel-filter";

export const ApplyButton: React.FC<{
  form: FormInstance<any>;
  handleApply: (values: ApplyValueStateType) => void;
  applyValue: ApplyValueStateType;
}> = ({ form, applyValue, handleApply }) => {
  const { timeRange } = useGetGeneralField({ form });
  const funnelBreakdownWatch = Form.useWatch(ChartFormFieldsEnum.FUNNEL_BREAKDOWN, form);
  const funnelBreakdownValueWatch = Form.useWatch(ChartFormFieldsEnum.FUNNEL_BREAKDOWN_VALUE, form);
  const eventListsWatch = Form.useWatch(ChartFormFieldsEnum.FUNNEL_EVENT_LISTS, form) ?? [];
  const filtersWatch = Form.useWatch(ChartFormFieldsEnum.FUNNEL_FILTER, form);

  const formatApplyValue = {
    timeRange: timeRange?.map((d) => d.format(config.DATE_FORMAT)) ?? [],
    breakdownBy: funnelBreakdownWatch,
    breakdownValues: funnelBreakdownWatch ? funnelBreakdownValueWatch : [],
    eventLists: eventListsWatch,
    filters: getRuleFilter(filtersWatch),
  };

  const isDisabledApply = JSON.stringify(formatApplyValue) === JSON.stringify(applyValue);
  return (
    <Button
      disabled={isDisabledApply}
      onClick={() => {
        form
          .validateFields([
            ChartFormFieldsEnum.FUNNEL_SIGNIFICANT + "_validate_field",
            ChartFormFieldsEnum.FUNNEL_BREAKDOWN,
            ChartFormFieldsEnum.FUNNEL_BREAKDOWN_VALUE + "_validate_field",
            ChartFormFieldsEnum.FUNNEL_EVENT_LISTS + "_validate_field",
            ChartFormFieldsEnum.FUNNEL_FILTER,
          ])
          .then(() => {
            handleApply(formatApplyValue);
          });
      }}
      type="primary"
    >
      Apply
    </Button>
  );
};
